import { DefaultService } from '@/services/DefaultService';

export default class TipoVeiculoService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

	changeSituacao(id, situacao) {
		return this._http.get(`${this._env}/despesa/tipoveiculo/activate/${id}?situacao=${situacao}`, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	updateSituacao(tipoveiculo) {
        return this._http.post(`${this._env}/despesa/tipoveiculo/updatesituacao`, tipoveiculo, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

	findAll(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/despesa/tipoveiculo.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/despesa/getcombo/tipoveiculo.json?param=${params}`), this._headers).then(res => {
				return res.body;
		}, err => {
				this.verifyError(err);
				throw new Error('Problems while jobs are loading');
		});
	}

	find(id) {
		return this._http.get(`${this._env}/despesa/tipoveiculo/${id}.json`, this._headers).then(res => {
		return res.body;
	}, err => {
		this.verifyError(err);
		throw new Error('Problems while jobs are loading');
	});
	}

	save(form) {
		return this._http.post(`${this._env}/despesa/tipoveiculo`, form, this._headers)
			.then(res => {
				return res.body;
			}, err => {
				this.verifyError(err);
				throw err;
			});
  }
	
}